;
/*!
 * subitotexto.soumission-ou.js
 */

// Purement décoratif
//  ------------
//  |
//  |
//  OU
//  |
//  |
//  ------------
//


SubitoTexto.soumissionOu = {
	init        : function () {

		var $ = jqPla,
			_this = SubitoTexto.soumissionOu;

		_this.$ouContainer = $( '.soumission-article-ou' );
		_this.blankMargin = 20;

		if ( _this.$ouContainer.length < 1 ) {
			// nothing to do here.
			return;
		}

		_this.$ouElement = _this.$ouContainer.find( '.ou-text' );
		_this.$containerFileInput = $( '.soumission-article-file-input' );
		_this.$containerRediger = $( '.soumission-article-rediger' );


		_this.appendBlocks();
		_this.adjustSizes();

		_this.bindEvents();


	},
	appendBlocks: function () {
		var $ = jqPla,
			_this = SubitoTexto.soumissionOu;

		_this.$ouBefore = $( '<div class="soumission-article-ou-before" />' ).prependTo( _this.$ouContainer );
		_this.$ouAfter = $( '<div class="soumission-article-ou-after" />' ).appendTo( _this.$ouContainer );
	},

	adjustSizes: function () {
		var $ = jqPla,
			_this = SubitoTexto.soumissionOu;

		var containerFileInputTop = _this.$containerFileInput.offset().top,
			containerFileInputLeft = _this.$containerFileInput.offset().left,
			containerFileInputHeight = _this.$containerFileInput.outerHeight(),
			containerFileInputWidth = _this.$containerFileInput.outerWidth(),

			containerRedigerTop = _this.$containerRediger.offset().top,
			containerRedigerLeft = _this.$containerRediger.offset().left
		containerRedigerHeight = _this.$containerRediger.outerHeight(),
			containerRedigerWidth = _this.$containerRediger.outerWidth(),

			ouContainerTop = _this.$ouElement.offset().top,
			ouContainerLeft = _this.$ouElement.offset().left,
			ouContainerHeight = _this.$ouElement.innerHeight(),
			ouContainerWidth = _this.$ouElement.innerWidth();



		_this.$ouBefore.css( {
			top   : -( ouContainerTop - ( containerFileInputTop + ( containerFileInputHeight / 2 ) ) ),
			left  : ouContainerWidth / 2,
			width : containerFileInputLeft - ouContainerLeft - (  ouContainerWidth / 2 ) - _this.blankMargin,
			height: containerFileInputTop + ( containerFileInputHeight / 2 ) - containerFileInputTop
		} );

		_this.$ouAfter.css( {
			bottom:  -( ouContainerTop - ( containerFileInputTop + ( containerFileInputHeight / 2 ) ) ),
			left  : ouContainerWidth / 2,
			width : containerRedigerLeft - ouContainerLeft - (  ouContainerWidth / 2 ) - _this.blankMargin,
			height: containerFileInputTop + ( containerFileInputHeight / 2 ) - containerFileInputTop
		} );

	},
	bindEvents: function() {
		var $ = jqPla,
			_this = SubitoTexto.soumissionOu;


		var debouncedResizeOu = PLA.UTILS.debounce( function () {
			_this.adjustSizes();
		}, 250 );

		window.addEventListener( 'resize', debouncedResizeOu );
	}

};
